'use strict'

require 'core-js/es6/function'
require 'core-js/es6/set'
require 'core-js/es6/map'
require 'core-js/es6/weak-map'
require 'core-js/es6/weak-set'
require 'core-js/fn/array/from'
require 'core-js/fn/array/find'
require 'core-js/fn/array/find-index'
require 'core-js/fn/object/keys'
require 'core-js/fn/object/entries'
require 'core-js/fn/object/assign'
require 'core-js/fn/object/values'
require 'core-js/fn/string/includes'
require 'core-js/fn/string/starts-with'

# https://github.com/WebReflection/dom4
require 'dom4'

if not window.Promise
  window.Promise = require 'promise-polyfill'

require 'whatwg-fetch'

require 'picturefill'
require 'intersection-observer'
require 'url-polyfill'

# IE11 https://developer.mozilla.org/de/docs/Web/API/Window/location
# http://tosbourn.com/a-fix-for-window-location-origin-in-internet-explorer/
window.location.origin or= window.location.protocol + "//" + window.location.host


###
# Chrome requestIdleCallback() shim: https://gist.github.com/paullewis/55efe5d6f05434a96c36
###
window.requestIdleCallback = window.requestIdleCallback or (cb) ->
  setTimeout((->
    start = Date.now()
    cb(
      didTimeout: false
      timeRemaining: -> Math.max(0, 50 - (Date.now() - start))
    )
  ), 1)

###
# Chrome cancelIdleCallback() shim: https://gist.github.com/paullewis/55efe5d6f05434a96c36
###
window.cancelIdleCallback = window.cancelIdleCallback or (id) -> clearTimeout(id)



// WEBPACK FOOTER //
// ./src/frontend/core/dom_js_shim.coffee